import CONSTANTS from '../../../Constants'
import ConfirmDialog from '../Dialog/ConfirmDialog'
type UnsavedPopupProps = {
  open: boolean
  onCloseDialog?: () => void
  onConfirm: (() => void) | (() => Promise<void>)
  onClose: () => void
}
const UnsavedPopup = ({ open, onConfirm, onCloseDialog, onClose }: UnsavedPopupProps) => {
  return (
    <ConfirmDialog
      open={open}
      onClose={onClose}
      onConfirm={onConfirm}
      onCloseDialog={onCloseDialog}
      title='Unsaved Changes'
      description={CONSTANTS.UNSAVED_CHANGES_DESCRIPTION}
      btn2Label={'Save Draft'}
      btn1Label='Discard Changes'
      btn2Color='warning'
      icon='DeleteRoleWarIcon'
      testID1='DiscardChangesBtn'
      testID2='SaveDraftBtn'
      disableBackdropClose
    />
  )
}

export default UnsavedPopup
